// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__16jEW","productName":"Table_productName__1nMlS"};